interface BookingContext {
  pricingMode: string;
  hasPickupOptions: boolean;
  hasReturnOptions: boolean;
  returnAtPickup: boolean;
  pickupBranch: string;
  returnBranch: string;
  pickupDate?: Date;
  returnDate?: Date;
  pickupTime: string;
  returnTime: string;
  pickupTimeRequired: boolean;
  returnTimeRequired: boolean;
}

/** Schedule completion is independent of the v1/v2 product selection. */
export function isBookingContextReady(context: BookingContext): boolean {
  if (context.hasPickupOptions && !context.pickupBranch) return false;
  if (!context.pickupDate || !Number.isFinite(context.pickupDate.getTime())) return false;
  if (context.pickupTimeRequired && !context.pickupTime) return false;
  if (context.pricingMode === "timeslot") return true;
  if (context.pricingMode !== "daily") return false;
  if (context.hasReturnOptions && !context.returnAtPickup && !context.returnBranch) return false;
  if (!context.returnDate || !Number.isFinite(context.returnDate.getTime())) return false;
  if (context.returnDate < context.pickupDate) return false;
  return !context.returnTimeRequired || !!context.returnTime;
}
